export default {
  computed: {
    getVariantName () {
      let variantName = ''
      let variantNames = this.$store.getters['productData/getVariantsNames']
      if (typeof variantNames === 'object') {
        if (variantNames[this.selectedVariant]) {
          variantName = variantNames[this.selectedVariant].name
        }
      }

        return this.error ? '' : variantName
      },
      getImages () {
          return this.error ? [] : this.$store.getters['productData/getImages'](this.selectedVariant)
      },
      getOnSale () {
          return this.error ? '' : this.$store.getters['productData/onSale'](this.selectedVariant)
      },
      getPrice () {
          return this.error ? '' : this.$store.getters['productData/getPrice'](this.selectedVariant)
      },
      getSalePrice () {
          return this.error ? '' : this.$store.getters['productData/getSalePrice'](this.selectedVariant)
      },
      getQuantity () {
          return this.error ? '' : this.$store.getters['productData/getQuantity'](this.selectedVariant)
      },
      getSku () {
          return this.error ? '' : this.$store.getters['productData/getSku'](this.selectedVariant)
      },
      getBaseSku () {
          return this.error ? '' : this.$store.getters['productData/getBaseSku'](this.selectedVariant)
      },
      getBackorderable () {
          return this.error ? '' : (this.$store.getters['productData/getBackorderable'](this.selectedVariant) &&
              this.$store.getters['productData/getQuantity'](this.selectedVariant) == 0)
      },
      getName () {
          return this.error ? '' : this.$store.getters['productData/getVariantName'](this.selectedVariant) || this.$store.getters['productData/getName']
      },
      getSlug () {
          return this.error ? '' : this.$store.getters['productData/getSlug'](this.selectedVariant)
      },
      getSupplierName() {
          return this.error ? '' : this.$store.getters['productData/getSupplierName']
      },
      getId() {
          return this.error ? '' : this.$store.getters['productData/getId']
      },
      getOptions () {
          return this.error ? {} : this.$store.getters['productData/getOptions'](this.$app_name === 'scout')
      },
      getShippingCategory () {
          return this.error ? '' : this.$store.getters['productData/getShippingCategory'](this.selectedVariant)
      },
      getBackorderableDate () {
          return this.error ? '' : this.$store.getters['productData/getBackorderableDate']
      },
      getEstimatedAvailabilityType () {
          return this.error ? '' : this.$store.getters['productData/getEstimatedAvailabilityType'](this.selectedVariant)
      },
      getEstimatedAvailabilityValue () {
          return this.error ? '' : this.$store.getters['productData/getEstimatedAvailabilityValue'](this.selectedVariant)
      },
      getDisplayNonReturnable () {
          return this.error ? '' : this.$store.getters['productData/getDisplayNonReturnable'](this.selectedVariant)
      },
      getMadeToOrder () {
          return this.error ? '' : this.$store.getters['productData/getMadeToOrder'](this.selectedVariant)
      },
      getGiftCard () {
          return this.error ? false : this.$store.getters['productData/getGiftCard']
      },
      getPurchasable () {
        return this.error ? false : this.$store.getters['productData/getPurchasable'](this.selectedVariant)
      }
  },
  methods: {
    getListingImage (displayType) {
      const image = this.getImages.find(image => image.display_type === displayType)
      return image ? image.images_url.listing : ''
    },
    getFormattedVariantOptions () {
        return Object.entries(this.getOptions[this.selectedVariant] || {}).map(([name, value]) => ({ name, value }))
    },
    getVariantPayload () {
      return {
        id: this.selectedVariant,
        slug: this.getSlug,
        name: this.getName,
        product_id: this.getId,
        supplier_name: this.getSupplierName,
        on_sale: this.getOnSale,
        main_image: this.getListingImage('main'),
        hover_image: this.getListingImage('hover'),
        price_show: this.getOnSale ? this.getSalePrice : this.getPrice,
        old_price_show:  this.getPrice,
        backorderable: this.getBackorderable,
        quantity: this.getQuantity,
        sku: this.getSku,
        base_sku: this.getBaseSku,
        variant_name: this.getVariantName,
        options: this.getFormattedVariantOptions(),
        images: this.getImages,
        shipping_category: this.getShippingCategory,
        backorderable_date: this.getBackorderableDate(this.selectedVariant),
        estimated_availability_type: this.getEstimatedAvailabilityType,
        estimated_availability_value: this.getEstimatedAvailabilityValue,
        display_non_returnable: this.getDisplayNonReturnable,
        made_to_order: this.getMadeToOrder,
        gift_card: this.getGiftCard,
        purchasable: this.getPurchasable
      }
    }
  }
}